export default function ({ app, redirect }) {
    // Redirect to login page if not authenticated
    if (!app.$localStore.get('authenticated')) {
        return redirect('/pianifica/autenticazione');
    }
}
